var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("billing-loading-modal", {
        attrs: {
          text: "Aguarde enquanto criamos o template da sua fatura",
          "is-active": _vm.savingBillingTemplate
        }
      }),
      _vm._v(" "),
      _c("sc-confirmation-modal", {
        attrs: {
          "is-active": _vm.isErrorModalActive,
          type: "normal",
          title:
            "Modelo já cadastrado para a transportadora e método de entrega selecionado",
          cancelText: "Selecionar outra transportadora e método de entrega",
          "confirm-text": "Continuar cadastro",
          messages: [
            "Identificamos que você já tem um modelo cadastrado para a transportadora e método de entrega selecionado.",
            "Caso você continue o cadastro, o modelo existente será substituído pelo novo. Se preferir, selecione outra transportadora e método de entrega."
          ]
        },
        on: {
          "update:isActive": function($event) {
            _vm.isErrorModalActive = $event
          },
          onConfirm: function() {
            return _vm.$emit("onOverwriteConfirm")
          },
          onCancel: function() {
            return _vm.$emit("onOverwriteCancel")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c88107de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c88107de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/NewBillingTemplateSavingModal.vue
// module id = null
// module chunks = 